import { Bar, CartesianGrid, ComposedChart, LabelList, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { HeadcountResult } from "models/hr-dashboard";

interface EmployeeMovementChartProps {
    data: HeadcountResult;
    title?: string;
}

// Bars: Hired / Left per month (right axis). Line: balance at the end of the month (left axis).
const EmployeeMovementChart = ({ data, title = "Employee Movement" }: EmployeeMovementChartProps) => {
    const rows = data.months
        .filter(m => m.values)
        .map(m => ({ label: m.label, hired: m.values!.hired, left: m.values!.left, hcEnd: m.values!.hcEnd }));

    if (rows.length === 0) return null;

    return (
        <div style={{ width: "100%" }}>
            <h4 className="text-muted mb-2">{title}</h4>
            <div style={{ width: "100%", height: 400 }}>
                <ResponsiveContainer width="100%" height="100%">
                    <ComposedChart data={rows} margin={{ top: 20, right: 10, left: 10, bottom: 10 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="label" />
                        <YAxis yAxisId="balance" orientation="left" domain={["dataMin - 10", "dataMax + 5"]} allowDecimals={false} />
                        <YAxis yAxisId="movement" orientation="right" allowDecimals={false} domain={[0, (max: number) => Math.max(5, max * 2)]} />
                        <Tooltip />
                        <Legend />
                        <Bar yAxisId="movement" dataKey="hired" name="Hired" fill="#4472c4">
                            <LabelList dataKey="hired" position="top" />
                        </Bar>
                        <Bar yAxisId="movement" dataKey="left" name="Left" fill="#ed7d31">
                            <LabelList dataKey="left" position="top" />
                        </Bar>
                        <Line yAxisId="balance" type="monotone" dataKey="hcEnd" name="Balance end of month" stroke="#29A9E0" strokeWidth={2}>
                            <LabelList dataKey="hcEnd" position="top" />
                        </Line>
                    </ComposedChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default EmployeeMovementChart;
